const state = () => ({
    _show: false,
});

const getters = {
    upgradePlanTrialModalState: (state) => state._show,
};

const actions = {
    showUpgradePlanTrialModal(status) {
        this._setUpgradePlanTrialModalShow(status);
    },

    _setUpgradePlanTrialModalShow(status) {
        this._show = status;
    },
};

export default {
    state,
    getters,
    actions,
};
